import { RootState } from '@/store';
import { api } from '../core';
import { getCaseDocuments } from '../case';

export interface DocumentBulkGetUploadItem {
  documentId: string;
  uploadPath: string;
  uploadToken: string;
}

export interface DocumentBulkGetUploadResponse {
  uploads: DocumentBulkGetUploadItem[];
}

type DocumentBulkGetUploadProps = {
  documentIds: string[];
};

const documentBulkGetUploadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentBulkGetUpload: builder.query<DocumentBulkGetUploadResponse, DocumentBulkGetUploadProps>({
      query: ({ documentIds }: DocumentBulkGetUploadProps) => ({
        url: `document/bulk-get-upload`,
        method: 'POST',
        body: {
          documentIds,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;
          const state = getState() as RootState;

          if (
            typeof state.case.caseId === 'string' &&
            state.caseDocuments.caseDocumentsPagination.pageIndex >= 0 &&
            state.caseDocuments.caseDocumentsPagination.pageSize > 0
          ) {
            dispatch(
              getCaseDocuments.initiate(
                {
                  caseId: state.case.caseId,
                  pageIndex: state.caseDocuments.caseDocumentsPagination.pageIndex,
                  pageSize: state.caseDocuments.caseDocumentsPagination.pageSize,
                },
                {
                  forceRefetch: true,
                },
              ),
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postDocumentBulkGetUpload in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyPostDocumentBulkGetUploadQuery } = documentBulkGetUploadApi;
